// extracted by mini-css-extract-plugin
export default {"chipContainer":"parameters_chipContainer__MqwDy","actionButtons":"parameters_actionButtons__0OkXr"};